import {
    combineReducers
} from 'redux'
import {
    firestoreReducer
} from 'redux-firestore'
import {
    firebaseReducer
} from 'react-redux-firebase'

import authReducer from './authReducer';
import projectReducer from './projectReducer';
import taskReducer from './taskReducer';
import navigationReducer from './navigationReducer';
import userReducer from './userReducer';
import formReducer from '../../components/create-form/store/formReducer';
import dFormReducer from '../../components/dynamic-form/store/dFormReducer';
import dAddFormReducer from '../../components/dynamic-form/store/dAddFormReducer';
import listReducer from './listReducer';

const rootReducer = combineReducers({
    auth: authReducer,
    project: projectReducer,
    task: taskReducer,
    navigation: navigationReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer,
    formReducer: formReducer,
    dFormReducer: dFormReducer,
    dAddFormReducer: dAddFormReducer,
    userReducer: userReducer,
    listReducer: listReducer
})

export default rootReducer